const screenWidth = {
	Mobile : 500,
	Tablet : 800,
	check  : 768
};

export default screenWidth;



// WEBPACK FOOTER //
// ./utils/constant.js